import { FileFieldInput } from '../../FileFieldInput'
import type { FieldInputProps } from '../types'

/**
 * EDIT-mode adapter dla FieldType=FILE. Wymaga {@code contractId} (upload do
 * /api/contracts/{id}/files) i {@code field.documentTypeId} (typ pliku z files BC).
 * Fallback do błędu inline gdy któryś brakuje -- zgodnie z oryginalnym FieldRenderer.
 */
export function FileInput({ field, value, onChange, disabled, contractId }: FieldInputProps) {
  if (!contractId || !field.documentTypeId) {
    return <div className="text-xs text-rose-600 italic">Pole FILE wymaga podpiętego typu dokumentu i kontekstu umowy.</div>
  }
  const fileId = typeof value === 'number'
    ? value
    : (typeof value === 'string' ? Number(value) || null : null)
  return (
    <FileFieldInput
      contractId={contractId}
      documentTypeId={field.documentTypeId}
      value={fileId}
      onChange={(fid) => onChange(fid)}
      disabled={disabled}
    />
  )
}
